import React from 'react';
import { Descriptions, Tag, Typography } from 'antd';
import type { RouteViewModel } from '../../../types/routeViewModel';

const { Text } = Typography;

type Props = {
  view: RouteViewModel;
};

/** Read-only finance / obligation preview from route view — no writes. */
export function ConsequencePreviewPanel({ view }: Props) {
  const finance = view.finance;
  const carrierFinance = view.carrierFinance;

  if (!finance && !carrierFinance) {
    return <Text type="secondary">Финансовые данные недоступны.</Text>;
  }

  const agg = finance?.aggregatedStatus;

  return (
    <div className="mutation-workspace__section">
      <div className="mutation-workspace__section-title">Финансовые последствия (просмотр)</div>

      {agg && (
        <Descriptions size="small" column={1} bordered style={{ marginBottom: 16 }}>
          <Descriptions.Item label="Общий статус">
            <Tag>{agg.overallStatus}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="К оплате перевозчику">
            <Tag>{agg.payableStatus}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="К получению от клиента">
            <Tag>{agg.receivableStatus}</Tag>
          </Descriptions.Item>
        </Descriptions>
      )}

      {finance?.payable && (
        <Descriptions size="small" column={2} title="Обязательства перевозчику" style={{ marginBottom: 16 }}>
          <Descriptions.Item label="Начислено">{finance.payable.totalRequired.toLocaleString('ru-RU')} ₽</Descriptions.Item>
          <Descriptions.Item label="Оплачено">{finance.payable.totalPaid.toLocaleString('ru-RU')} ₽</Descriptions.Item>
          <Descriptions.Item label="Остаток">{finance.payable.remaining.toLocaleString('ru-RU')} ₽</Descriptions.Item>
          <Descriptions.Item label="Просрочка">{finance.payable.overdue.toLocaleString('ru-RU')} ₽</Descriptions.Item>
        </Descriptions>
      )}

      {carrierFinance?.rateAmount != null && (
        <Text type="secondary">
          Ставка по договору: {carrierFinance.rateAmount.toLocaleString('ru-RU')} ₽
        </Text>
      )}

      {view.routePenalties.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <Text strong>Зафиксированные штрафы: </Text>
          <Text>{view.routePenalties.length}</Text>
        </div>
      )}
    </div>
  );
}
